import styles from './TaskStatusPickerField.module.scss';

import { CheckCircleRounded, CircleTwoTone } from '@mui/icons-material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ITaskStatusPickerProps,
  TaskStatusPicker,
} from '@work4all/components/lib/components/entity-picker/task-status-picker/TaskStatusPicker';

import { TaskStatus } from '@work4all/models/lib/Enums/TaskStatus.enum';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props extends Omit<ITaskStatusPickerProps<false>, 'onChange'> {
  error?: string;
  label?: string;
  onChange: (value: string) => void;
}

export const TaskStatusPickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { error, label, ...pickerProps } = props;
    const { value, onChange } = pickerProps;

    const { t } = useTranslation();

    const valueIsDone = TaskStatus.ERLEDIGT === value?.id;

    const Icon = valueIsDone ? CheckCircleRounded : CircleTwoTone;

    return (
      <EntityPickerPopover
        picker={
          <TaskStatusPicker
            {...pickerProps}
            onChange={(value) => onChange(value.id)}
          />
        }
      >
        <PickerTargetButton
          ref={ref}
          startAdornment={
            value && (
              <Icon
                className={clsx(styles['check-circle'], {
                  [styles['check-circle-success']]:
                    value.id === TaskStatus.ERLEDIGT,
                  [styles['check-circle-edit']]:
                    value.id === TaskStatus.IN_BEARBEITUNG ||
                    value.id === TaskStatus.WARTET ||
                    value.id === TaskStatus.ZURUECK_GESTELLT,
                })}
              />
            )
          }
          label={label || t('INPUTS.STATUS')}
          error={error}
          value={value ? t(`TASK_STATUS.${value?.id || value}`) : ''}
        />
      </EntityPickerPopover>
    );
  }
);
